import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import useResizable from '../hooks/useResizable';
import css from './PreviewPanel.css';
import ArtifactWithInsights from './artifacts/ArtifactWithInsights';

const MIN_PANEL_WIDTH_PERCENT = 10;
const MAX_PANEL_WIDTH_PERCENT = 90;
const DEFAULT_PANEL_WIDTH_PERCENT = 60;
const STORAGE_KEY = 'previewPanelWidth';

const PreviewPanel = ({ artifacts }) => {
    const { widthPercent, elementRef, handleMouseDown } = useResizable({
        minPercent: MIN_PANEL_WIDTH_PERCENT,
        maxPercent: MAX_PANEL_WIDTH_PERCENT,
        defaultPercent: DEFAULT_PANEL_WIDTH_PERCENT,
        storageKey: STORAGE_KEY,
    });

    if (!artifacts || artifacts.length === 0) {
        return (
            <div ref={elementRef} className={css.previewPanel} style={{ width: `${widthPercent}%` }}>
                <div className={css.resizeHandle} onMouseDown={handleMouseDown} />
                <div className={css.previewPanelContent}>
                    <div className={css.previewPanelPlaceholder}>
                        <Icon name="chart-bar" size={IconSizes.X_LARGE} className={css.previewPanelIcon} />
                        <div className={css.previewPanelPlaceholderTitle}>Preview Panel</div>
                        <div className={css.previewPanelPlaceholderText}>
                            Visualizations and structured outputs will appear here
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div ref={elementRef} className={css.previewPanel} style={{ width: `${widthPercent}%` }}>
            <div className={css.resizeHandle} onMouseDown={handleMouseDown} />
            <div className={css.previewPanelContent}>
                {artifacts.map(artifact => (
                    <div key={artifact.id} className={css.artifactContainer}>
                        <ArtifactWithInsights artifact={artifact} />
                    </div>
                ))}
            </div>
        </div>
    );
};

PreviewPanel.propTypes = {
    artifacts: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            type: PropTypes.string,
            format: PropTypes.string,
            data: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
            metadata: PropTypes.object,
            timestamp: PropTypes.string,
        })
    ),
    messages: PropTypes.array,
};

export default PreviewPanel;
